import { Collapse, Modal, Select, Skeleton, Spin, Button, message, Tooltip, Image } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { checkAccess } from './Auth'
import { UR_LoanProcessor } from './State'
import './WelcomePage.css'

import Swiper from 'react-id-swiper'
import { useHistory, useLocation } from 'react-router-dom'
import smartlookClient from 'smartlook-client'
import { getEnvironment, isHardMoneyLoanCustomer } from './Common'
import { shouldRecordSmartlook } from 'utils'
import { handleAuthExpired } from './syncStrataSession.js'
import { patchStatsigIdentity } from './statsig/logEvent'
import { track } from 'statsig'
import { STATSIG, PAGE, dashboardFeatureItem } from 'statsig/events'

import dayjs from 'dayjs'
import LodestarIntegrationNotice from './Management/estimatedclosingfee/components/LodestarIntegrationNotice'
import isEqual from 'lodash/isEqual'
import throttle from 'lodash/throttle'

function WelcomePage(props) {
    const customerid = JSON.parse(sessionStorage.getItem('statsig_user_info') || "{}")?.custom?.customerid;
    const dispatch = useDispatch()
    const [isMounted, setIsMounted] = useState(true)
    const [closingfeeConfig, setClosingfeeConfig] = useState(null)
    const [companyName, setCompanyName] = useState('')
    const [profile, setProfile] = useState(null)
    const [notifications, setNotifications] = useState(null)
    const [plotsData, setPlotsData] = useState({})
    const [allLoan, setAllLoan] = useState([])
    const [loans, setLoans] = useState([])
    const [isEnd, setIsEnd] = useState(false)
    const [pageLoading, setpageLoading] = useState(false)
    const [publishModule, setPublishModule] = useState([])
    const [selectTime, setSelectTime] = useState('month')
    const [loading, setLoading] = useState(false)
    const [isLP, setIsLP] = useState(null)
    const [rateSelection, setRateSelection] = useState([])
    const [borrowerTasks, setBorrowerTasks] = useState([])
    const [setupGuideStatus, setSetupGuideStatus] = useState({
        exploreLoans: false,
        tryPricingEngine: false,
        tryMortgageGPT: false,
        tryAffordabilityCalculator: false,
        hideGuide: false,
    })
    const [guideStatusDone, setGuideStatusDone] = useState(false)
    const [currentLOProfile, setCurrentLOProfile] = useState(null)
    const [featuresList, setFeaturesList] = useState([
        // {
        //     id: 1,
        //     key: 'addLender',
        //     status: 0,
        //     name: 'Add a lender',
        //     operateText: 'Get started',
        //     link: 'management?select=lender'
        // },
        // {
        //     id: 2,
        //     key: 'addBorrower',
        //     status: 0,
        //     name: 'Add a borrower',
        //     operateText: 'Get started',
        //     link: 'borrowers'
        // },
        {
            id: 3,
            key: 'completeProfile',
            status: 0,
            name: 'Complete your profile ',
            operateText: 'Get started',
            link: 'profile',
        },
        // {
        //     id: 4,
        //     key: 'exploreLoans',
        //     status: 0,
        //     name: 'Explore your loans',
        //     operateText: 'Get started',
        //     link: 'loans'
        // },
        {
            id: 5,
            key: 'tryPricingEngine',
            status: 0,
            name: 'Try pricing engine',
            operateText: 'Try now',
            link: 'ppe-pricing',
        },
        {
            id: 6,
            key: 'tryMortgageGPT',
            status: 0,
            name: 'Try guideline',
            operateText: 'Try now',
            link: 'mortgagegpt',
        },
        {
            id: 7,
            key: 'tryAffordabilityCalculator',
            status: 0,
            name: 'Try affordability calculator',
            operateText: 'Try now',
            link: 'affordability',
            params:{
                customerid
            }
        },
        {
            id: 8,
            key: 'setUpWebsite',
            status: 0,
            name: 'Set up your Website',
            operateText: 'Get started',
            link: 'landingpage',
        },
    ])
    const swiperRef = useRef(null)
    const hasShownLodestarNotice = useRef(false);
    const [currentIndex, updateCurrentIndex] = useState(0)
    const [link, setLink] = useState('')
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const isMobile = window.innerWidth < 576
    const history = useHistory()

    const location = useLocation()
    const [isAllApiCompleted, setIsAllApiCompleted] = useState(false)
    const [LoanOfficersList, setLoanOfficersList] = useState([])
    const [CompanyInfo, setCompanyInfo] = useState(false)
    const [EmailInfo, setEmailInfo] = useState(false)
    const [WebsiteInfo, setWebsiteInfo] = useState(false)
    const [currentNum, setCurrentNum] = useState(0)
    const [LendersList, setLenders] = useState(0)
    const ishardmoneyloancustomer = isHardMoneyLoanCustomer()
    const { first, open } = useSelector((state) => {
        return state.manager
    })
    const borrower = useSelector(state => {
        return state.borrower
    })

    // 获取订阅信息 - 使用本地state而不是Redux store
    const [subscription, setSubscription] = useState(null)

    const [configurations, setConfigurations] = useState(null)
    const [showVerificationDialog, setShowVerificationDialog] = useState(false)
    const [isLodestarNoticeOpen, setIsLodestarNoticeOpen] = useState(false)
    // 添加推荐弹窗状态
    const [showRecommendationModal, setShowRecommendationModal] = useState(false)
    const marketplaceUrl = useMemo(() => {
        const env = getEnvironment()
        switch (env) {
            case 'development':
                return 'http://localhost:3006'
            case 'staging':
                return 'https://staging.bluerate.ai'
            case 'production':
                return 'https://www.bluerate.ai'
            default:
                return 'https://www.bluerate.ai'
        }
    }, [])

    const throttledHandleGuide = useMemo(
        () =>
            throttle(
                () => {
                    setGuideStatusDone(true)
                    setSetupGuideStatus((prevState) => {
                        const hiding = !prevState.hideGuide
                        track(
                            STATSIG.DASHBOARD.HIDE_SETUP_GUIDE,
                            hiding ? 'hide' : 'open'
                        )
                        return {
                            ...prevState,
                            hideGuide: hiding,
                        }
                    })
                    setLink('')
                },
                500,
                { trailing: false }
            ),
        []
    )

    const defaultLodeStarConfig = {
        suggestEnableCount: 1,
        isModified: false,
        enableOriginationCharges: false,
        enableCanNotShopServices: false,
        enableCanShopServices: false,
        enableTaxesAndOtherGovernmentFees: false,
        enablePrepaids: false,
        enableInitialEscrowPaymentsAtClosing: false,
        enableOther: false
    }

    const setFirstFinish = () => {
        if (LendersList == 0) {
            dispatch({ type: 'FIRST_NO_FINISH', data: 0 })
            return
        }
        if (LoanOfficersList == 1) {
            dispatch({ type: 'FIRST_NO_FINISH', data: 1 })
            return
        }
        if (!CompanyInfo) {
            dispatch({ type: 'FIRST_NO_FINISH', data: 2 })
            return
        }
        if (!EmailInfo) {
            dispatch({ type: 'FIRST_NO_FINISH', data: 3 })
            return
        }
        if (!WebsiteInfo) {
            dispatch({ type: 'FIRST_NO_FINISH', data: 4 })
            return
        }
    }

    const getLender = async (token) => {
        const response = await fetch('/data/getcustomerlenders', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
        const data = await response.json()
        setLenders( data.Lenders == null ? 0 : data.Lenders.filter(item => !item.Hidden && item.Active).length)
    }

    const getCompany = async (token) => {
        const response = await fetch('/los/getcompanyprofilesetup', {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
        const data = await response.json()
        const hasNonEmptyField = Object.values(data).some(value => value && value !== '')
        setCompanyInfo(hasNonEmptyField)
    }

    const getWebsite = async (token) => {
        const response = await fetch('/los/getprofilesetup', {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
        const data = await response.json()
        const website = data?.LandingPageSetUp?.SetupGuideStatus?.ZeitroWidget
        const value = website == undefined ? false : website
        setWebsiteInfo(value)
        dispatch({ type: "WEB_SITE_INFO", data: value })
    }

    const getOldEmailConfig = async () => {
        try {
            const response = await fetch('/los/getEmailConfigDetails', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
                    Cache: "no-cache",
                    'Content-Type': 'application/json'
                },
            });
            
            if (!response.ok) {
                message.error(`Error: ${response.statusText}`);
                return false;
            }
            
            const res = await response.json();
            const data = res.data;
            
            if (data.Email?.Provider === "Gmail" && data.Email?.Keys?.GmailAPIKey) {
                return true;
            } else if (data.Email?.Provider === "Outlook" && data.Email?.Keys?.SecretValue) {
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error fetching old email config:', error);
            return false;
        }
    }

    const getEmail = async (token) => {
        const response = await fetch('/los/getcommunicationconfig', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
        const data = await response.json()
        const hasOldEmailSetup = await getOldEmailConfig();
        setEmailInfo(data.IndividualEmail?.Email ? true : (hasOldEmailSetup ? true : false))
    }

    const getLoanOfficers = async (token) => {
        const response = await fetch('/los/loanofficerlist', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
                'X-Image-Free': 'true',
            },
        })
        const { LoanOfficers } = await response.json()
        setLoanOfficersList(LoanOfficers.length)
    }

    // 获取最新的订阅信息
    const getSubscription = async (token) => {
        try {
            const response = await fetch('/los/getcurrentsubscription', {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token,
                    Cache: 'no-cache',
                },
            })

            if (response.status === 401) {
                handleAuthExpired()
                window.location.href = '/login'
                return
            }

            if (response.ok) {
                const data = await response.json()
                setSubscription(data)
            } else {
                console.error('Failed to fetch subscription:', response.status)
            }
        } catch (error) {
            console.error('Error fetching subscription:', error)
        }
    }

    useEffect(() => {
        if (open) return

        const fetchAllData = async () => {
            const token = sessionStorage.getItem('ZeitroA');
            try {
                // wait for all api to complete
                await Promise.all([
                    getCompany(token),
                    getLender(token),
                    getEmail(token),
                    getWebsite(token),
                    getLoanOfficers(token),
                    getSubscription(token),
                ]);

                setIsAllApiCompleted(true)
            } catch (error) {
                console.error('API call failed:', error)
            }
        };

        fetchAllData()
    }, [open])

    // 检查订阅信息中的 notified 字段
    useEffect(() => {
        if (subscription) { //subscription.notified !== undefined
            // 如果 notified 字段不是 true，则显示推荐弹窗
            if (subscription.notified !== true) {
                setShowRecommendationModal(true)
            }
        }
    }, [subscription])

    // 更新 notified 值为 true 的函数
    const updateNoticedStatus = async () => {
        try {
            const token = sessionStorage.getItem('ZeitroA')
            const response = await fetch('/los/updateplanupdatesnotified', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token,
                    Cache: 'no-cache',
                },
                // body: JSON.stringify({
                //     notified: true
                // })
            })
            
            if (response.ok) {
                // API 调用成功后，再更新本地状态
                setSubscription({ 
                    ...subscription, 
                    notified: true 
                })
            } else {
                console.error('Failed to update notified status:', response.status)
            }
        } catch (error) {
            console.error('Error updating notified status:', error)
        }
    }

    // 处理弹窗关闭
    const handleModalClose = () => {
        setShowRecommendationModal(false)
        // 更新 notified 状态
        updateNoticedStatus()
    }

    useEffect(() => {
        if (isAllApiCompleted) {
            dispatch({ type: "FIRST", data: LoanOfficersList > 1 && CompanyInfo && EmailInfo && WebsiteInfo && LendersList > 0 })
            dispatch({ type: "IS_FINISHED", data: LoanOfficersList > 1 || CompanyInfo || EmailInfo || WebsiteInfo || LendersList > 0 })
            setFirstFinish()
        }
    }, [isAllApiCompleted, LoanOfficersList, CompanyInfo, EmailInfo, WebsiteInfo, LendersList])

    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.DASHBOARD, { page: PAGE.DASHBOARD })
        if (checkAccess(['Owner'])) {
            setFeaturesList([
                {
                    id: 0,
                    key: 'lodestar',
                    status: 0,
                    name: 'Lodestar for closing costs',
                    operateText: 'Get started',
                    link: 'lodestar',
                },
                {
                    id: 2,
                    key: 'addBorrower',
                    status: 0,
                    name: 'Manager setup',
                    operateText: 'Resume',
                    link: 'manager',
                },
                ...featuresList,
            ])
        }

        // Removed automatic onboarding popup trigger after signup
        // Users can manually access onboarding via "Resume" button in "Explore our system features" card on dashboard

        getLoInfo()
        reload()
        getCustomerLenders()
        getProfile()
        if (checkAccess(UR_LoanProcessor)) {
            setIsLP(true)
        } else {
            setIsLP(false)
        }
        getLoans()
        getloanestimatedclosingfee()
    }, [])
    useEffect(() => {
        filterLoan(selectTime)
    }, [allLoan])

    useEffect(() => {
        if (guideStatusDone) {
            updateProfile()
            if (link !== '') {
                history.push(link)
            }
            updateCurrentIndex(0)
            setIsEnd(false)
        }
    }, [guideStatusDone, link, setupGuideStatus.hideGuide])

    useEffect(() => {
        setFeaturesList((prevList) => {
            return prevList.map((item) => {
                if (item.id === 3 && completeProfile()) {
                    return { ...item, status: 1 }
                }
                if (item.id === 8 && isPublish()) {
                    return { ...item, status: 1 }
                }
                return item
            })
        })
    }, [publishModule])

    useEffect(() => {
        const token = sessionStorage.getItem('ZeitroA')
        fetch('/los/getfeaturecustomization', {
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        }).then((response) => {
            response.json().then((data) => {
                setConfigurations(data)
                // Only show verification dialog if the user is on marketplace and never seen it
                if (data.OnMarketplace && !data.PromptVerified) {
                    setShowVerificationDialog(true)
                }
            })
        })
    }, [])

    useEffect(() => {
        return () => {
            setIsMounted(false)
        }
    }, [])

    const handleVisitProfile = useCallback(async () => {
        setShowVerificationDialog(false)

        try {
            const token = sessionStorage.getItem('ZeitroA')
            const response = await fetch(
                '/los/getloanofficernotificationsandprofile',
                {
                    cache: 'no-cache',
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + token,
                        Cache: 'no-cache',
                    },
                }
            )
            const data = await response.json()
            const firstNameSlug = data.Profile.FirstName?.replace(/ /g, '-')
            const lastNameSlug = data.Profile.LastName?.replace(/ /g, '-')
            const savedUserInfo = JSON.parse(
                sessionStorage.getItem('statsig_user_info')
            )
            const customerId = savedUserInfo.custom.customerid
            const profileUrl = `${marketplaceUrl}/loan-officer/${firstNameSlug}-${lastNameSlug}-nmls-${data.Profile.Nmls}?customerid=${customerId}`
            window.open(profileUrl, '_blank')

            await fetch('/los/setfeaturecustomization', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                    Cache: 'no-cache',
                },
                body: JSON.stringify({
                    ...configurations,
                    PromptVerified: true,
                }),
            })
        } catch (error) {
            console.error(error)
        }
    }, [configurations])

    const params = {
        on: {
            slideChange: (index) => {
                updateCurrentIndex(index.realIndex)
                setIsEnd(index.isEnd)
            },
        },
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 12,
        breakpoints: {
            1400: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 1,
            },
            300: {
                slidesPerView: 1,
            },
        },
    }

    const goNext = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext()
        }
    }

    const goPrev = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev()
        }
    }

    const divs = []
    for (let i = 0; i < 100; i++) {
        divs.push(<div key={i}>This is div {i + 1}</div>)
    }

    const filterLoan = (type) => {
        const currentDate = new Date()
        const selectDate = new Date()
        if (type === 'week') {
            selectDate.setDate(selectDate.getDate() - 7)
        } else {
            selectDate.setDate(selectDate.getDate() - 30)
        }
        const sortDate = (a, b) => {
            const dateA = new Date(a.started)
            const dateB = new Date(b.started)
            return dateB - dateA
        }
        const filteredData = allLoan.sort(sortDate).filter((item) => {
            const startedDate = new Date(item.started)
            return startedDate >= selectDate && startedDate <= currentDate
        })
        setLoans(filteredData)
    }

    const getPurpose = (purpose, hascontract, unknownpurpose) => {
        if (purpose === 'refinance') return 'Rate/Term Refinance'
        if (purpose === 'cashoutrefinance') return 'Cash-out Refinance'
        if (purpose === 'purchase') {
            if (unknownpurpose) return 'TBD'
            if (!hascontract) return 'Pre-qualification'
            return 'Purchase'
        }
        return 'TBD'
    }

    const getIcon = (purpose) => {
        if (purpose === 'Purchase' || purpose === 'Pre-qualification') {
            return '/images/purchase.svg'
        } else {
            return '/images/refinance.svg'
        }
    }

    const isPublish = () => {
        return (
            publishModule.includes(1) &&
            publishModule.includes(2) &&
            publishModule.includes(3)
        )
    }

    const completeProfile = () => {
        return publishModule.includes(4)
    }

    const processLoans = (loans) => {
        let data = []
        let borrowerMap = {}
        for (let loan of loans) {
            if (loan.email in borrowerMap) {
                if (loan.lastTouch > borrowerMap[loan.email].lastTouch) {
                    borrowerMap[loan.email] = loan
                }
            } else {
                borrowerMap[loan.email] = loan
            }
        }
        for (let bo in borrowerMap) {
            data.push(borrowerMap[bo])
        }
        return data
    }

    const getLoans = () => {
        const token = sessionStorage.getItem('ZeitroA')
        fetch('/los/loanlist', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
                'X-Past': false,
                'X-LP': isLP ? true : false,
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log(
                        'Looks like there was a problem. Status Code: ' +
                            response.status
                    )
                    return
                }
                response.json().then((js) => {
                    if (js.Status !== 'OK') {
                        console.log('Error: ' + js.Text)
                    } else {
                        let docs = js.Loans.filter(
                            (s) =>
                                s.Source !== 'marketplace' &&
                                s.Source !== 'personalsite'
                        )
                        let data = processLoans(docs)
                        setFeaturesList((prevList) => {
                            return prevList.map((item) => {
                                if (item.id === 2) {
                                    return {
                                        ...item,
                                        status: data.length > 0 ? 1 : 0,
                                    }
                                }
                                return item
                            })
                        })
                    }
                })
            })
            .catch(function (err) {
                console.log('Fetch Error :-S', err)
            })
    }
    const getloanestimatedclosingfee = () => {
        let token = sessionStorage.getItem("ZeitroA")
        setLoading(true)
        fetch("/los/getloanestimatedclosingfee", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
          },
        })
        .then((response) => {
            setLoading(false)
            if (response.status !== 200) {
                alert(
                    "Looks like there was a problem. Status Code: " + response.status
                );
                return
            }
            response.json().then((js) => {
                if (js.status !== "OK") {
                console.log("Error: " + js.Error)
                } else {
                    let data = js.configurations
                    if (data) {
                        if (!data.lodeStarConfig) {
                            data.lodeStarConfig = defaultLodeStarConfig;
                        }
                        setClosingfeeConfig(data);
                        // Removed automatic Lodestar integration popup trigger after signup
                        // Users can manually setup Lodestar in Management > Closing cost settings
                    }
                }
            })
        })
        .catch(function (err) {
            setLoading(false)
            console.log("Fetch Error :-S", err);
        })
    }

    const setEnableCount = (count) => {
        let data = {
            lodeStarConfig: {
                ...closingfeeConfig.lodeStarConfig,
                suggestEnableCount: count
            },
            closingCostsDetail: closingfeeConfig.estimatedClosingCostsDetail
        }
        let token = sessionStorage.getItem("ZeitroA");
        fetch("/los/setloanestimatedclosingfee", {
            cache: "no-cache",
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
                Cache: "no-cache",
            },
            body: JSON.stringify(data)
          }).then(response => {
            if (!response.ok) {

            } else {
                getloanestimatedclosingfee()
            }
        }).catch(error => {

        })
    }
    const getProfile = () => {
        const token = sessionStorage.getItem('ZeitroA')
        fetch('/los/getprofilesetup', {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
            .then((response) => {
                if (response.ok) {
                    response.json().then((js) => {
                        if (!isMounted) return
                        let lo = js
                        setCurrentLOProfile(lo)
                        let su = lo.LandingPageSetUp
                        let basicInfo = {
                            file:
                                lo.Image === ''
                                    ? []
                                    : [
                                          {
                                              url: lo.Image,
                                          },
                                      ],
                            firstname: lo.FirstName,
                            lastname: lo.LastName,
                            nmls: lo.NMLS,
                            states:
                                typeof su.States === 'undefined'
                                    ? []
                                    : su.States,
                            tagsList:
                                typeof su.TagsList === 'undefined'
                                    ? []
                                    : su.TagsList,
                            popularTags: [
                                'I speak Mandarin',
                                'Self-Employed borrowers',
                                'Bay Area for 10+ years',
                            ],
                        }
                        let aboutInfo = {
                            introduction: lo.Introduction,
                            phone: lo.Phone,
                            email: su.Email ? su.Email : lo.Email,
                            companyWebsite:
                                su.CompanyWebsite === undefined
                                    ? ''
                                    : su.CompanyWebsite,
                            google: su.Google === undefined ? '' : su.Google,
                            yelp: su.Yelp === undefined ? '' : su.Yelp,
                            linkedin:
                                su.Linkedin === undefined ? '' : su.Linkedin,
                            twitter: su.Twitter === undefined ? '' : su.Twitter,
                        }
                        if (
                            Object.keys(basicInfo).length !== 0 &&
                            basicInfo.file.length > 0 &&
                            basicInfo.firstname !== '' &&
                            basicInfo.lastname !== '' &&
                            !publishModule.includes(1)
                        ) {
                            setPublishModule((prev) => [...prev, 1])
                        }
                        if (
                            Object.keys(aboutInfo).length !== 0 &&
                            aboutInfo.introduction !== '' &&
                            aboutInfo.phone !== '' &&
                            aboutInfo.email !== '' &&
                            !publishModule.includes(2)
                        ) {
                            setPublishModule((prev) => [...prev, 2])
                        }
                        if (
                            Object.keys(aboutInfo).length !== 0 &&
                            lo.Image !== '' &&
                            basicInfo.firstname !== '' &&
                            basicInfo.lastname !== '' &&
                            aboutInfo.phone !== '' &&
                            aboutInfo.email !== '' &&
                            basicInfo.nmls !== '' &&
                            !publishModule.includes(4)
                        ) {
                            setPublishModule((prev) => [...prev, 4])
                        }
                        if (
                            su.SetupGuideStatus &&
                            typeof su.SetupGuideStatus !== 'underfined'
                        ) {
                            if (!isEqual(su.SetupGuideStatus, setupGuideStatus)) {
                                setSetupGuideStatus(su.SetupGuideStatus)
                                setFeaturesList((prevList) => {
                                    return prevList.map((item) => {
                                        const { key } = item
                                        if (
                                            su.SetupGuideStatus.hasOwnProperty(key)
                                        ) {
                                            return {
                                                ...item,
                                                status: su.SetupGuideStatus[key]
                                                    ? 1
                                                    : 0,
                                            }
                                        }
                                        return item
                                    })
                                })
                            }
                        }
                    })
                }
            })
            .catch((error) => {
                console.log('Revalidate catch error ' + error)
            })
    }

    const updateProfile = () => {
        let tosend = {
            FirstName: currentLOProfile.FirstName,
            LastName: currentLOProfile.LastName,
            NMLS: currentLOProfile.NMLS,
            Image: currentLOProfile.Image,
            Phone: currentLOProfile.Phone,
            Introduction: currentLOProfile.Introduction,
            LandingPageSetUp: {
                ...currentLOProfile.LandingPageSetUp,
                SetupGuideStatus: setupGuideStatus,
            },
        }

        const token = sessionStorage.getItem('ZeitroA')

        fetch('/los/updateprofilesetup', {
            method: 'POST',
            body: JSON.stringify(tosend),
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console(
                        'Looks like there was a problem. Status Code: ' +
                            response.status
                    )
                    return
                }
                getProfile()
            })
            .catch(function (err) {
                console.log('Fetch Error :-S', err)
            })
    }

    const reload = () => {
        setLoading(true)
        const token = sessionStorage.getItem('ZeitroA')
        fetch('/los/loansforloanofficer', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.log(
                        'Looks like there was a problem. Status Code: ' +
                            response.status
                    )
                    if (isMounted) {
                        setLoading(false)
                    }
                    return
                }
                response.json().then((js) => {
                    if (!isMounted) return
                    if (js.Status !== 'OK') {
                        setLoading(false)
                        console.log('Error: ' + js.Text)
                    } else {
                        if (js.Borrowers) {
                            let docs = js.Borrowers.filter(
                                (s) =>
                                    s.Source !== 'marketplace' &&
                                    s.Source !== 'personalsite'
                            ).map((s) => {
                                return {
                                    rand: Math.random(),
                                    id: s.ID,
                                    loan_id: s.LoanID,
                                    firstname: s.FirstName,
                                    lastname: s.LastName,
                                    email: s.Email,
                                    status: s.Status,
                                    started: s.ReceivedDate,
                                    phone: s.ContactPhone,
                                    los_id: s.LoanOfficerID,
                                    purpose: getPurpose(
                                        s.LoanPurpose,
                                        s.HasContract,
                                        s.UnknownPurpose
                                    ),
                                    hascontract: s.HasContract,
                                    unknownpurpose: s.UnknownPurpose,
                                    address: s.PropertyAddressStreet,
                                    county: s.PropertyAddressCounty,
                                    state: s.PropertyAddressState,
                                }
                            })
                            let rateSelection = docs.filter(
                                (item) => item.status === 'productselected'
                            )
                            setRateSelection(rateSelection)
                            let borrowerTasks = docs.filter(
                                (item) => item.status === 'loansubmitted'
                            )
                            setBorrowerTasks(borrowerTasks)
                            setAllLoan(docs)
                        }
                        setLoading(false)
                    }
                })
            })
            .catch(function (err) {
                if (isMounted) {
                    setLoading(false)
                }
                console.error('Fetch Error :-S', err)
            })
    }

    const getCustomerLenders = () => {
        const token = sessionStorage.getItem('ZeitroA')
        fetch('/data/getcustomerlenders', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
            .then((response) => {
                if (response.status !== 200) {
                    console.warn(
                        'Looks like there was a problem. Status Code: ' +
                            response.status
                    )
                    return
                }
                // Examine the text in the response
                response.json().then((js) => {
                    if (js.Status === 'OK') {
                        if (js.Lenders !== null) {
                            const hasLenders = js.Lenders.some(
                                (item) => !item.Hidden && item.Active
                            )
                            if (hasLenders && !publishModule.includes(3)) {
                                setPublishModule((prev) => [...prev, 3])
                            }
                            setFeaturesList((prevList) => {
                                return prevList.map((item) => {
                                    if (item.id === 1) {
                                        return {
                                            ...item,
                                            status: hasLenders ? 1 : 0,
                                        }
                                    }
                                    return item
                                })
                            })
                        }
                    }
                })
            })
            .catch(function (err) {
                console.error('Fetch Error :-S', err)
            })
    }

    const getLoInfo = () => {
        const token = window.sessionStorage.getItem('ZeitroA')
        fetch('/los/getloanofficernotificationsandprofile', {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
            },
        })
            .then((response) => {
                let d = new Date()
                if (response.ok && isMounted) {
                    response.json().then((js) => {
                        if (!isMounted) return
                        setCompanyName(js.CompanyName)
                        setProfile(js.Profile)
                        setNotifications(js.Notifications)
                        setPlotsData(js.Performance)
                        patchStatsigIdentity({
                            user_id: js.Profile?.ID,
                            user_account: js.Profile?.Email,
                            org_name: js.CompanyName,
                        })
                        if (shouldRecordSmartlook()) {
                            smartlookClient.init(
                                'abc8514fc7e47edf16ab4fd8e6bc6b653296e642'
                            )
                            smartlookClient.record({
                                emails: true,
                                forms: true,
                                numbers: true,
                                ips: true,
                            })
                            smartlookClient.identify(js.Profile.ID, {
                                name:
                                    js.Profile.FirstName +
                                    ' ' +
                                    js.Profile.LastName,
                                email: js.Profile.Email,
                            })
                        }
                    })
                }
            })
            .catch((error) => {
                let d = new Date()
                console.log(
                    'Revalidate catch error ' +
                        error +
                        ', at: ' +
                        d.toLocaleString()
                )
            })
    }

    if (profile === null) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center vh-100 px-5">
                <Skeleton active className="mb-5" />
                <Skeleton active className="mb-5" />
                <Skeleton active />
            </div>
        )
    }

    const handleTime = (value) => {
        setSelectTime(value)
        filterLoan(value)
    }

    const switchLoan = (loanid, item) => {
        sessionStorage.setItem('edit', 'false')
        console.log(sessionStorage.getItem('edit'))
        sessionStorage.setItem('state', '{}')
        sessionStorage.setItem('originalstate', '{}')
        sessionStorage.setItem('borrowermenu', 'loanSummary')
        dispatch({ type: "CHANGE_BORROWER_ID", data: item.id })
        dispatch({ type: "CHANGE_BORROWER_LOAN_ID", data: loanid })
        sessionStorage.setItem("borrowObj", JSON.stringify(item))
        track(STATSIG.DASHBOARD.RECENT_LOANS_OPEN)
        history.push('/app/borrower/' + loanid)
    }

    const getLoanList = () => {
        if (loans.length === 0) {
            return (
                <div className="noApplication">
                    <div>
                        <div
                            style={{
                                fontSize: 16,
                                color: '#101820',
                                fontWeight: 600,
                                lineHeight: '20px',
                                marginBottom: 8,
                            }}
                        >
                            No application added
                        </div>
                        <div
                            style={{
                                fontSize: 14,
                                color: '#6E6E70',
                                lineHeight: '20px',
                            }}
                        >
                            Add borrower's information to explore recent loans.
                        </div>
                    </div>
                    <img src="/images/no-loan-icon.svg" />
                </div>
            )
        } else {
            return (
                <div className="loan-list">
                    {loans.map((item) => (
                        <div className="loan-item" key={item.loan_id}>
                            <div className="loan-icon">
                                <img src={getIcon(item.purpose)} />
                            </div>
                            <div className="loan-info">
                                <div className="loan-info-top">
                                    <div>
                                        <span style={{ fontWeight: 600 }}>
                                            {item.purpose}
                                        </span>{' '}
                                        |{' '}
                                        <span
                                            style={{ fontWeight: 400 }}
                                        >{`${item.firstname} ${item.lastname}`}</span>
                                    </div>
                                    <div
                                        className="loans-view-btn"
                                        onClick={() => switchLoan(item.loan_id, item)}
                                    >
                                        View
                                    </div>
                                </div>
                                <div className="loan-info-bottom">
                                    <div>
                                        {item.email}{' '}
                                        {item.phone !== '' && <span>·</span>}{' '}
                                        {item.phone}
                                    </div>
                                    <div style={{ color: '#6E6E70' }}>
                                        {dayjs(item.started).format(
                                            'MM/DD/YYYY'
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )
        }
    }

    const handleFeatures = (item) => {
        let target = item.link || ''
        if (item.link === 'lodestar') {
            target = '/app/management?select=estimatedclosingfee'
        } else if (item.link === 'manager') {
            target = ''
        } else {
            if (item.params) {
                target += `/${Object.values(item.params || {}).join('/')}`
            }
            if (target && !target.startsWith('/')) {
                target = `/app/${target}`
            }
        }
        const featureItem = dashboardFeatureItem(item.key)
        const value = target || featureItem
        track(STATSIG.DASHBOARD.FEATURES_ITEM_CLICK, value, featureItem ? { item: featureItem } : undefined)
        switch (item.link) {
            case 'manager':
                dispatch({ type: 'STEP', data: 0 })
                dispatch({ type: 'OPEN', data: true })
                dispatch({ type: 'SHOW_ACHIEVEMENT', data: true })
                dispatch({ type: 'SHOW_LENDERS', data: false })
                dispatch({ type: 'SHOW_PRICiNG', data: false })
                dispatch({ type: 'SELECT_LENDERS', data: true })
                dispatch({ type: 'selectLenders', data: true })
                break
            case 'lodestar':
                history.push('/app/management?select=estimatedclosingfee')
                break
            default:
                break
        }
        if (item.link == 'manager' || item.link == 'lodestar') return
        setGuideStatusDone(true)
        if ([4, 5, 6, 7].includes(item.id) && !setupGuideStatus[item.key]) {
            setSetupGuideStatus((prevState) => ({
                ...prevState,
                [item.key]: true,
            }))
        }
        if (item.params) {
            item.link += `/${Object.values(item.params || {}).join('/')}`;
        }
        setLink(item.link)
    }

    const svg_free_plan = () => {
        return <div style={{width: '410px', height: '236px'}}>
            <img src="/images/free_plan.png" />
        </div>
    }
    const svg_paid_plan = () => {
        return <div style={{width: '410px', height: '236px'}}>
            <img src="/images/paid_plan.png" />
      </div>       
    }

    return (
        <div className="welcomPageWrap">
            <Spin spinning={loading}>
                <div className="welcomePageDashboard">
                    <div style={{ paddingLeft: 15 }} className="welcomeMessage">
                        Hi,
                        <span style={{ marginLeft: 8 }}>
                            {profile !== null ? profile.FirstName : ''}
                        </span>
                    </div>
                    {!ishardmoneyloancustomer && (
                        <div className="systemFeatures">
                            <div className="systemFeatures-top">
                                <div className="systemFeatures-top-text">
                                    <div>Explore our system features</div>
                                    <div>
                                        Complete setting up your account and
                                        explore our features
                                    </div>
                                </div>
                                <div
                                    className="systemFeatures-top-btn"
                                    onClick={throttledHandleGuide}
                                >
                                    {!setupGuideStatus.hideGuide
                                        ? 'Hide'
                                        : 'Display'}{' '}
                                    setup guide
                                </div>
                            </div>
                            {!setupGuideStatus.hideGuide && (
                                <div className="systemFeatures-list">
                                    <Swiper
                                        ref={swiperRef}
                                        {...params}
                                        style={{ marginTop: 20 }}
                                    >
                                        {featuresList.map((item, index) => (
                                            <div
                                                className={
                                                    item.link == 'manager'
                                                        ? ' systemFeatures-item systemManager'
                                                        : 'systemFeatures-item'
                                                }
                                                key={index}
                                            >
                                                <div className="features-item-left">
                                                    <div>
                                                        <div className="status text-wrap">
                                                            {item.link ==
                                                            'manager' ? (
                                                                <>
                                                                    {!first ? (
                                                                        <span className="status-mark incomplete"></span>
                                                                    ) : (
                                                                        <img
                                                                            className="status-mark complete"
                                                                            src="/images/navSignFinished.png"
                                                                        />
                                                                    )}
                                                                    <span
                                                                        className={`status-text ${
                                                                            !first
                                                                                ? 'incomplete'
                                                                                : 'complete'
                                                                        }`}
                                                                        style={{
                                                                            color: '#858585',
                                                                            fontFamily:
                                                                                'Inter',
                                                                            fontSize: 12,
                                                                        }}
                                                                    >
                                                                        {!first
                                                                            ? 'Incomplete'
                                                                            : 'Complete'}
                                                                    </span>
                                                                </>
                                                            ) : item.link == 'lodestar' ? (
                                                                <>
                                                                    <span className="lodestar-status-mark"></span>
                                                                    <span className="lodestar-status-text">New!</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {item.status ===
                                                                    0 ? (
                                                                        <span className="status-mark incomplete"></span>
                                                                    ) : (
                                                                        <img
                                                                            className="status-mark complete"
                                                                            src="/images/navSignFinished.png"
                                                                        />
                                                                    )}
                                                                    <span
                                                                        className={`status-text ${
                                                                            item.status ===
                                                                            0
                                                                                ? 'incomplete'
                                                                                : 'complete'
                                                                        }`}
                                                                    >
                                                                        {item.status ===
                                                                        0
                                                                            ? 'Incomplete'
                                                                            : 'Complete'}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                        {item.link ==
                                                        'manager' ? (
                                                            <div
                                                                className="features-name"
                                                                style={
                                                                    !first
                                                                        ? {
                                                                              color: '#325ceb',
                                                                              fontFamily:
                                                                                  'Inter',
                                                                              fontWeight: 500,
                                                                              fontSize: 16,
                                                                          }
                                                                        : {
                                                                              fontFamily:
                                                                                  'Inter',
                                                                              fontWeight: 500,
                                                                              fontSize: 16,
                                                                          }
                                                                }
                                                            >
                                                                {item.name}
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className="features-name"
                                                                style={{
                                                                    fontFamily:
                                                                        'Inter',
                                                                    fontWeight: 500,
                                                                    fontSize: 14,
                                                                }}
                                                            >
                                                                {item.name}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className="features-operate"
                                                        onClick={() =>
                                                            handleFeatures(item)
                                                        }
                                                    >
                                                        {item.operateText}
                                                    </div>
                                                </div>
                                                <div className="features-item-right">
                                                    <img
                                                        className="features-img"
                                                        src={`/images/systemFeatures/features-${
                                                            index
                                                        }.svg`}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </Swiper>
                                    {currentIndex !== 0 && (
                                        <div className="prev-btn-box swiper-btn">
                                            <img
                                                src="/images/systemFeatures/swiper-btn.svg"
                                                onClick={goPrev}
                                            />
                                        </div>
                                    )}
                                    {!isEnd && (
                                        <div className="next-btn-box swiper-btn">
                                            <img
                                                src="/images/systemFeatures/swiper-btn.svg"
                                                onClick={goNext}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    <Row gutter={32}>
                        <Col lg={8} style={{marginTop: 32}}>
                            <div className="recentLoans">
                                <span
                                    style={{
                                        fontSize: '18px',
                                        color: '#000',
                                        fontWeight: 500,
                                        lineHeight: 'normal',
                                    }}
                                >
                                    My recent loans
                                </span>
                                <Select
                                    suffixIcon={
                                        <img src="/images/select-arrow.svg" />
                                    }
                                    value={selectTime}
                                    style={{
                                        width: 130,
                                        height: 38,
                                        color: '#000',
                                        fontSize: 14,
                                    }}
                                    onChange={handleTime}
                                    options={[
                                        {
                                            value: 'month',
                                            label: 'Last 30 days',
                                        },
                                        {
                                            value: 'week',
                                            label: 'Last 7 days',
                                        },
                                    ]}
                                />
                            </div>
                            {getLoanList()}
                        </Col>
                        <Col lg={4} style={{marginTop: 32}}>
                            <div className="scenarioAI-card">
                               <img className='scenarioAI-card-img' src="/images/scenarioAI-card.png" alt="Strata AI" />
                               <div className="scenarioAI-card-content">
                                    <div className="scenarioAI-card-title">Strata AI</div>
                                    <div className="scenarioAI-card-text">
                                        From FHA to Non-QM, Strata AI delivers fast, accurate answers to your toughest lending questions
                                    </div>
                                    <Tooltip title='Book a demo for fully customized Strata AI'>
                                        <Button className="scenarioAI-card-btn" 
                                            style={{
                                                marginRight : 10,
                                                color: '#325CEB',
                                                background: '#F7F8FF',
                                                border: '1px solid #325CEB',
                                            }}
                                            onClick={() => {
                                                track(STATSIG.DASHBOARD.STRATA, { type: 'demo' })
                                                window.open('https://www.zeitro.com/demo', '_blank')
                                            }}
                                        >
                                            Book a Demo
                                        </Button>
                                    </Tooltip>

                                    <Button type='primary' className="scenarioAI-card-btn" 
                                            onClick={() => {
                                                track(STATSIG.DASHBOARD.STRATA, { type: 'try' })
                                                history.push('/app/mortgagegpt')
                                            }}
                                    >
                                        Try it now
                                    </Button>
                               </div>
                            </div>
                        </Col>
                        {/* <Col lg={4}>
                            <div className="overview">
                                <div className="overview-title">Overview</div>
                                <div className="TCD-wrap">
                                    <div className="rate-selection">
                                        <Collapse
                                            ghost
                                            className="dashboard-collapse inside processing-collapse"
                                            collapsible="icon"
                                            expandIconPosition="end"
                                            expandIcon={({ isActive }) =>
                                                isActive &&
                                                rateSelection.length > 0 ? (
                                                    <img
                                                        className="down"
                                                        src="/images/systemFeatures/swiper-btn.svg"
                                                    />
                                                ) : !isActive &&
                                                  rateSelection.length > 0 ? (
                                                    <img
                                                        className="up"
                                                        src="/images/systemFeatures/swiper-btn.svg"
                                                    />
                                                ) : null
                                            }
                                            items={[
                                                {
                                                    key: '1',
                                                    label: (
                                                        <div className="dashboard-card-header">
                                                            <div className="header-title">
                                                                {ishardmoneyloancustomer
                                                                    ? 'Target Closing date'
                                                                    : 'Rate selection'}
                                                            </div>
                                                            <div>
                                                                <span className="num">
                                                                    {
                                                                        rateSelection.length
                                                                    }
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        color: ishardmoneyloancustomer
                                                                            ? '#08979C'
                                                                            : '',
                                                                    }}
                                                                    className="unit"
                                                                >
                                                                    {ishardmoneyloancustomer
                                                                        ? 'processing'
                                                                        : 'Borrowers'}
                                                                </span>
                                                            </div>
                                                            <div className="sub-title">
                                                                {ishardmoneyloancustomer
                                                                    ? 'are running late'
                                                                    : 'need rate recommendations'}
                                                            </div>
                                                        </div>
                                                    ),
                                                    children: (
                                                        <div className="dashboard-card-content">
                                                            {rateSelection.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => (
                                                                    <div
                                                                        className="content-item"
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <span className="name">{`${item.firstname} ${item.lastname}`}</span>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    ),
                                                },
                                            ]}
                                        />
                                    </div>
                                    {ishardmoneyloancustomer && (
                                        <>
                                            <div className="divider"></div>
                                            <div className="borrower-tasks">
                                                <Collapse
                                                    ghost
                                                    className="dashboard-collapse inside underwriting-collapse"
                                                    collapsible="icon"
                                                    expandIconPosition="end"
                                                    expandIcon={({
                                                        isActive,
                                                    }) =>
                                                        isActive &&
                                                        borrowerTasks.length >
                                                            0 ? (
                                                            <img
                                                                className="down"
                                                                src="/images/systemFeatures/swiper-btn.svg"
                                                            />
                                                        ) : !isActive &&
                                                          borrowerTasks.length >
                                                              0 ? (
                                                            <img
                                                                className="up"
                                                                src="/images/systemFeatures/swiper-btn.svg"
                                                            />
                                                        ) : null
                                                    }
                                                    items={[
                                                        {
                                                            key: '1',
                                                            label: (
                                                                <div className="dashboard-card-header">
                                                                    <div>
                                                                        <span className="num">
                                                                            {
                                                                                borrowerTasks.length
                                                                            }
                                                                        </span>
                                                                        <span
                                                                            style={{
                                                                                color: '#325CEB',
                                                                            }}
                                                                            className="unit"
                                                                        >
                                                                            underwriting
                                                                        </span>
                                                                    </div>
                                                                    <div className="sub-title">
                                                                        are
                                                                        running
                                                                        late
                                                                    </div>
                                                                </div>
                                                            ),
                                                            children: (
                                                                <div className="dashboard-card-content">
                                                                    {borrowerTasks.map(
                                                                        (
                                                                            item
                                                                        ) => (
                                                                            <div
                                                                                className="content-item"
                                                                                key={
                                                                                    item.LoanID
                                                                                }
                                                                            >
                                                                                <span className="name">{`${item.firstname} ${item.lastname}`}</span>
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                                {ishardmoneyloancustomer && (
                                    <div
                                        style={{ marginBottom: 18 }}
                                        className="borrower-tasks"
                                    >
                                        <Collapse
                                            ghost
                                            className="dashboard-collapse"
                                            collapsible="icon"
                                            expandIconPosition="end"
                                            expandIcon={({ isActive }) =>
                                                isActive &&
                                                borrowerTasks.length > 0 ? (
                                                    <img
                                                        className="down"
                                                        src="/images/systemFeatures/swiper-btn.svg"
                                                    />
                                                ) : !isActive &&
                                                  borrowerTasks.length > 0 ? (
                                                    <img
                                                        className="up"
                                                        src="/images/systemFeatures/swiper-btn.svg"
                                                    />
                                                ) : null
                                            }
                                            items={[
                                                {
                                                    key: '1',
                                                    label: (
                                                        <div className="dashboard-card-header">
                                                            <div className="header-title">
                                                                To Do
                                                            </div>
                                                            <div>
                                                                <span className="num">
                                                                    {
                                                                        borrowerTasks.length
                                                                    }
                                                                </span>
                                                                <span className="unit">
                                                                    Comments
                                                                </span>
                                                            </div>
                                                            <div className="sub-title">
                                                                are addressed to
                                                                me
                                                            </div>
                                                        </div>
                                                    ),
                                                    children: (
                                                        <div className="dashboard-card-content">
                                                            {borrowerTasks.map(
                                                                (item) => (
                                                                    <div
                                                                        className="content-item"
                                                                        key={
                                                                            item.LoanID
                                                                        }
                                                                    >
                                                                        <span className="name">{`${item.firstname} ${item.lastname}`}</span>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    ),
                                                },
                                            ]}
                                        />
                                    </div>
                                )}
                                <div className="borrower-tasks">
                                    <Collapse
                                        ghost
                                        className="dashboard-collapse"
                                        collapsible="icon"
                                        expandIconPosition="end"
                                        expandIcon={({ isActive }) =>
                                            isActive &&
                                            borrowerTasks.length > 0 ? (
                                                <img
                                                    className="down"
                                                    src="/images/systemFeatures/swiper-btn.svg"
                                                />
                                            ) : !isActive &&
                                              borrowerTasks.length > 0 ? (
                                                <img
                                                    className="up"
                                                    src="/images/systemFeatures/swiper-btn.svg"
                                                />
                                            ) : null
                                        }
                                        items={[
                                            {
                                                key: '1',
                                                label: (
                                                    <div className="dashboard-card-header">
                                                        <div className="header-title">
                                                            Borrower task
                                                            progress
                                                        </div>
                                                        <div>
                                                            <span className="num">
                                                                {
                                                                    borrowerTasks.length
                                                                }
                                                            </span>
                                                            <span className="unit">
                                                                Borrowers
                                                            </span>
                                                        </div>
                                                        <div className="sub-title">
                                                            with pending tasks
                                                        </div>
                                                    </div>
                                                ),
                                                children: (
                                                    <div className="dashboard-card-content">
                                                        {borrowerTasks.map(
                                                            (item) => (
                                                                <div
                                                                    className="content-item"
                                                                    key={
                                                                        item.LoanID
                                                                    }
                                                                >
                                                                    <span className="name">{`${item.firstname} ${item.lastname}`}</span>
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                ),
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        </Col> */}
                    </Row>
                </div>
            </Spin>

            {/* Marketplace verification success dialog */}
            <Modal
                className="login-tips-modal"
                centered={true}
                open={showVerificationDialog}
                onOk={() => {
                    setShowVerificationDialog(false)
                }}
                onCancel={() => {
                    setShowVerificationDialog(false)
                }}
                width={552}
                maskClosable={false}
                closable={true}
                footer={
                    <div className="login-tips-modal-footer">
                        <div
                            className="close-btn"
                            onClick={() => {
                                setShowVerificationDialog(false)
                            }}
                        >
                            Close
                        </div>
                        <div
                            className="visit-profile-btn"
                            onClick={handleVisitProfile}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.25013 7.24167C7.69324 7.24167 7.2418 7.69312 7.2418 8.25001C7.2418 8.8069 7.69324 9.25834 8.25013 9.25834C8.80702 9.25834 9.25846 8.8069 9.25846 8.25001C9.25846 7.69312 8.80702 7.24167 8.25013 7.24167ZM5.5918 8.25001C5.5918 6.78185 6.78197 5.59167 8.25013 5.59167C9.71829 5.59167 10.9085 6.78185 10.9085 8.25001C10.9085 9.71816 9.71829 10.9083 8.25013 10.9083C6.78197 10.9083 5.5918 9.71816 5.5918 8.25001Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.02606 13.1915C5.45023 13.4794 5.40817 13.7246 5.40817 13.75C5.40817 14.2944 5.44766 14.3226 5.51769 14.3727C5.52017 14.3744 5.52269 14.3762 5.52524 14.3781C5.61366 14.4421 5.82133 14.5455 6.27613 14.6273C6.72464 14.708 7.35823 14.7583 8.24983 14.7583C9.14143 14.7583 9.77503 14.708 10.2235 14.6273C10.6783 14.5455 10.886 14.4421 10.9744 14.3781C10.977 14.3762 10.9795 14.3744 10.982 14.3727C11.052 14.3226 11.0915 14.2944 11.0915 13.75C11.0915 13.7246 11.0494 13.4795 10.4736 13.1915C9.9471 12.9283 9.16203 12.7417 8.24983 12.7417C7.33761 12.7417 6.55254 12.9283 6.02606 13.1915ZM5.28816 11.7157C6.08875 11.3154 7.13701 11.0917 8.24983 11.0917C9.36264 11.0917 10.4109 11.3154 11.2115 11.7157C11.9627 12.0913 12.7415 12.7629 12.7415 13.75C12.7415 13.7697 12.7416 13.7903 12.7417 13.8117C12.7435 14.2778 12.7469 15.132 11.9419 15.7147C11.572 15.9824 11.0922 16.1475 10.5157 16.2512C9.93297 16.3561 9.19157 16.4083 8.24983 16.4083C7.3081 16.4083 6.56669 16.3561 5.98396 16.2512C5.40751 16.1475 4.92767 15.9824 4.55776 15.7147C3.75277 15.132 3.75615 14.2778 3.758 13.8117C3.75808 13.7903 3.75817 13.7697 3.75817 13.75C3.75817 12.7629 4.53691 12.0914 5.28816 11.7157Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M5.25323 4.61856C4.34624 4.7405 3.84875 4.96584 3.49061 5.32398C3.4906 5.32398 3.49061 5.32397 3.49061 5.32398M3.49061 5.32398C3.13247 5.68212 2.90713 6.17961 2.78519 7.08661C2.66005 8.01734 2.6583 9.2482 2.6583 11C2.6583 12.7518 2.66005 13.9827 2.78519 14.9134C2.90713 15.8204 3.13247 16.3179 3.49059 16.676L3.49061 16.676C3.84875 17.0342 4.34624 17.2595 5.25324 17.3815C6.18397 17.5066 7.41483 17.5083 9.16663 17.5083H12.8333C14.5851 17.5083 15.816 17.5066 16.7467 17.3815C17.6537 17.2595 18.1512 17.0342 18.5093 16.676L18.5093 16.676C18.8675 16.3179 19.0928 15.8204 19.2147 14.9134C19.3399 13.9827 19.3416 12.7518 19.3416 11C19.3416 9.2482 19.3399 8.01734 19.2147 7.08661C19.0928 6.17961 18.8675 5.68212 18.5093 5.32398L18.5093 5.32396C18.1512 4.96585 17.6537 4.74051 16.7467 4.61856C15.816 4.49343 14.5851 4.49168 12.8333 4.49168H9.16663C7.41483 4.49168 6.18397 4.49343 5.25323 4.61856M9.1056 2.84168H12.8943C14.571 2.84165 15.9131 2.84164 16.9666 2.98327C18.0565 3.12982 18.9603 3.44144 19.676 4.15727C20.3919 4.87307 20.7035 5.77679 20.85 6.86675C20.9917 7.92023 20.9917 9.26231 20.9916 10.939V11.061C20.9917 12.7377 20.9917 14.0798 20.85 15.1333C20.7035 16.2232 20.3918 17.127 19.676 17.8428C18.9602 18.5586 18.0565 18.8702 16.9666 19.0167C15.9131 19.1584 14.571 19.1584 12.8943 19.1583H9.1056C7.42894 19.1584 6.08686 19.1584 5.03337 19.0167C3.94341 18.8702 3.0397 18.5586 2.3239 17.8428C1.60807 17.127 1.29644 16.2232 1.1499 15.1333C1.00826 14.0798 1.00828 12.7377 1.0083 11.061V10.939C1.00828 9.26231 1.00826 7.92023 1.1499 6.86675C1.29644 5.77678 1.60807 4.87306 2.32388 4.15725C3.03968 3.44145 3.94341 3.12982 5.03338 2.98327C6.08686 2.84164 7.42894 2.84165 9.1056 2.84168Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12.9248 11C12.9248 10.5444 13.2942 10.175 13.7498 10.175H17.4165C17.8721 10.175 18.2415 10.5444 18.2415 11C18.2415 11.4557 17.8721 11.825 17.4165 11.825H13.7498C13.2942 11.825 12.9248 11.4557 12.9248 11Z"
                                    fill="white"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12.0083 8.25005C12.0083 7.79441 12.3777 7.42505 12.8333 7.42505H17.4166C17.8723 7.42505 18.2416 7.79441 18.2416 8.25005C18.2416 8.70568 17.8723 9.07505 17.4166 9.07505H12.8333C12.3777 9.07505 12.0083 8.70568 12.0083 8.25005Z"
                                    fill="white"
                                />
                                <path
                                    opacity="0.9"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.8418 13.75C13.8418 13.2944 14.2112 12.925 14.6668 12.925H17.4168C17.8724 12.925 18.2418 13.2944 18.2418 13.75C18.2418 14.2057 17.8724 14.575 17.4168 14.575H14.6668C14.2112 14.575 13.8418 14.2057 13.8418 13.75Z"
                                    fill="white"
                                />
                            </svg>
                            <span>Visit my profile page</span>
                        </div>
                    </div>
                }
            >
                <div className="login-tips-modal-content">
                    {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="113"
                        height="38"
                        viewBox="0 0 113 38"
                        fill="none"
                    >
                        <path
                            d="M41.7701 2.08105H44.141L46.1522 7.02875H46.2451L48.2563 2.08105H50.6272V10.0723H48.763V5.16361H48.6972L46.7943 10.0216H45.603L43.7001 5.1363H43.6343V10.0723H41.7701V2.08105Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M51.4269 2.08105H53.5657L55.2405 5.42504H55.3101L56.9848 2.08105H59.1237L56.2267 7.40334V10.0723H54.3238V7.40334L51.4269 2.08105Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M41.7701 13.9847H44.141L46.1522 18.9324H46.2451L48.2563 13.9847H50.6272V21.9759H48.763V17.0672H48.6972L46.7943 21.9252H45.603L43.7001 17.0399H43.6343V21.9759H41.7701V13.9847Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M59.2977 17.9803C59.2977 18.8595 59.1301 19.6048 58.7949 20.2161C58.4597 20.8274 58.0059 21.2918 57.4335 21.6091C56.8636 21.9265 56.2242 22.0852 55.5151 22.0852C54.8034 22.0852 54.1626 21.9252 53.5928 21.6052C53.023 21.2853 52.5704 20.8209 52.2352 20.2122C51.9026 19.6009 51.7363 18.8569 51.7363 17.9803C51.7363 17.101 51.9026 16.3558 52.2352 15.7445C52.5704 15.1331 53.023 14.6688 53.5928 14.3515C54.1626 14.0341 54.8034 13.8754 55.5151 13.8754C56.2242 13.8754 56.8636 14.0341 57.4335 14.3515C58.0059 14.6688 58.4597 15.1331 58.7949 15.7445C59.1301 16.3558 59.2977 17.101 59.2977 17.9803ZM57.3406 17.9803C57.3406 17.46 57.2672 17.0204 57.1202 16.6614C56.9758 16.3024 56.7669 16.0306 56.4936 15.8459C56.2229 15.6612 55.8967 15.5689 55.5151 15.5689C55.136 15.5689 54.8098 15.6612 54.5365 15.8459C54.2632 16.0306 54.0531 16.3024 53.9061 16.6614C53.7617 17.0204 53.6895 17.46 53.6895 17.9803C53.6895 18.5005 53.7617 18.9402 53.9061 19.2992C54.0531 19.6581 54.2632 19.93 54.5365 20.1147C54.8098 20.2994 55.136 20.3917 55.5151 20.3917C55.8967 20.3917 56.2229 20.2994 56.4936 20.1147C56.7669 19.93 56.9758 19.6581 57.1202 19.2992C57.2672 18.9402 57.3406 18.5005 57.3406 17.9803Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M60.4155 21.9759V13.9847H63.6876C64.2807 13.9847 64.7925 14.0926 65.2231 14.3085C65.6563 14.5218 65.9902 14.8288 66.2248 15.2294C66.4595 15.6274 66.5768 16.0995 66.5768 16.6458C66.5768 17.1999 66.4569 17.6707 66.2171 18.0583C65.9773 18.4433 65.637 18.7373 65.196 18.9402C64.7551 19.1405 64.233 19.2406 63.6296 19.2406H61.5604V17.7189H63.2738C63.5626 17.7189 63.8036 17.6811 63.997 17.6057C64.193 17.5277 64.3413 17.4106 64.4418 17.2545C64.5424 17.0958 64.5927 16.8929 64.5927 16.6458C64.5927 16.3987 64.5424 16.1945 64.4418 16.0332C64.3413 15.8693 64.193 15.7471 63.997 15.6664C63.8011 15.5832 63.56 15.5416 63.2738 15.5416H62.33V21.9759H60.4155ZM64.875 18.3237L66.8476 21.9759H64.759L62.8251 18.3237H64.875Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M67.3678 15.5533V13.9847H74.0628V15.5533H71.661V21.9759H69.7735V15.5533H67.3678Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M79.8345 16.5951C79.7906 16.4312 79.7262 16.2868 79.6411 16.162C79.556 16.0345 79.4516 15.9265 79.3278 15.8381C79.204 15.7497 79.0622 15.6833 78.9023 15.6391C78.7425 15.5923 78.5671 15.5689 78.3763 15.5689C77.9921 15.5689 77.6595 15.6625 77.3785 15.8498C77.1 16.0371 76.8847 16.3102 76.7325 16.6692C76.5804 17.0256 76.5043 17.4587 76.5043 17.9686C76.5043 18.481 76.5778 18.9181 76.7248 19.2796C76.8718 19.6412 77.0845 19.917 77.363 20.1069C77.6415 20.2968 77.9792 20.3917 78.3763 20.3917C78.727 20.3917 79.0235 20.3345 79.2659 20.22C79.5109 20.103 79.6965 19.9378 79.8229 19.7245C79.9492 19.5112 80.0124 19.2601 80.0124 18.9714L80.3682 19.0143H78.4421V17.6057H81.8573V18.6631C81.8573 19.3785 81.7065 19.9911 81.4048 20.501C81.1057 21.0108 80.6931 21.4023 80.1671 21.6755C79.6437 21.9486 79.0416 22.0852 78.3609 22.0852C77.6054 22.0852 76.9414 21.92 76.369 21.5896C75.7965 21.2592 75.3505 20.7884 75.0307 20.1771C74.711 19.5632 74.5511 18.8348 74.5511 17.992C74.5511 17.3365 74.6478 16.7551 74.8412 16.2478C75.0346 15.738 75.3041 15.3061 75.6496 14.9524C75.9977 14.5986 76.3999 14.3306 76.8563 14.1486C77.3153 13.9665 77.8091 13.8754 78.3377 13.8754C78.7966 13.8754 79.2234 13.9417 79.6179 14.0744C80.015 14.2071 80.3656 14.3944 80.6699 14.6363C80.9767 14.8782 81.2256 15.1657 81.4164 15.4986C81.6072 15.8316 81.7258 16.1971 81.7722 16.5951H79.8345Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M84.4545 21.9759H82.3969L85.0695 13.9847H87.6183L90.2909 21.9759H88.2333L86.3729 15.9981H86.311L84.4545 21.9759ZM84.1799 18.8309H88.4808V20.2981H84.1799V18.8309Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M95.9697 16.5951C95.9259 16.4312 95.8614 16.2868 95.7763 16.162C95.6913 16.0345 95.5868 15.9265 95.4631 15.8381C95.3393 15.7497 95.1975 15.6833 95.0376 15.6391C94.8777 15.5923 94.7024 15.5689 94.5116 15.5689C94.1274 15.5689 93.7948 15.6625 93.5137 15.8498C93.2352 16.0371 93.0199 16.3102 92.8678 16.6692C92.7157 17.0256 92.6396 17.4587 92.6396 17.9686C92.6396 18.481 92.7131 18.9181 92.8601 19.2796C93.007 19.6412 93.2198 19.917 93.4982 20.1069C93.7767 20.2968 94.1145 20.3917 94.5116 20.3917C94.8623 20.3917 95.1588 20.3345 95.4012 20.22C95.6461 20.103 95.8318 19.9378 95.9581 19.7245C96.0845 19.5112 96.1477 19.2601 96.1477 18.9714L96.5035 19.0143H94.5773V17.6057H97.9926V18.6631C97.9926 19.3785 97.8417 19.9911 97.54 20.501C97.2409 21.0108 96.8284 21.4023 96.3024 21.6755C95.7789 21.9486 95.1768 22.0852 94.4961 22.0852C93.7406 22.0852 93.0767 21.92 92.5042 21.5896C91.9318 21.2592 91.4857 20.7884 91.166 20.1771C90.8463 19.5632 90.6864 18.8348 90.6864 17.992C90.6864 17.3365 90.7831 16.7551 90.9765 16.2478C91.1699 15.738 91.4393 15.3061 91.7848 14.9524C92.1329 14.5986 92.5352 14.3306 92.9916 14.1486C93.4505 13.9665 93.9443 13.8754 94.4729 13.8754C94.9319 13.8754 95.3586 13.9417 95.7531 14.0744C96.1502 14.2071 96.5009 14.3944 96.8052 14.6363C97.112 14.8782 97.3608 15.1657 97.5516 15.4986C97.7425 15.8316 97.8611 16.1971 97.9075 16.5951H95.9697Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M99.121 21.9759V13.9847H104.644V15.5533H101.036V17.1921H104.362V18.7646H101.036V20.4073H104.644V21.9759H99.121Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M41.7701 34.3373V26.3461H45.0422C45.6352 26.3461 46.1471 26.4541 46.5777 26.67C47.0109 26.8833 47.3448 27.1902 47.5794 27.5908C47.8141 27.9888 47.9314 28.461 47.9314 29.0073C47.9314 29.5613 47.8115 30.0322 47.5717 30.4198C47.3319 30.8048 46.9915 31.0987 46.5506 31.3016C46.1097 31.5019 45.5875 31.6021 44.9842 31.6021H42.9149V30.0803H44.6283C44.9171 30.0803 45.1582 30.0426 45.3516 29.9671C45.5476 29.8891 45.6958 29.772 45.7964 29.616C45.897 29.4573 45.9472 29.2544 45.9472 29.0073C45.9472 28.7601 45.897 28.5559 45.7964 28.3946C45.6958 28.2308 45.5476 28.1085 45.3516 28.0279C45.1556 27.9446 44.9145 27.903 44.6283 27.903H43.6846V34.3373H41.7701ZM46.2296 30.6851L48.2021 34.3373H46.1135L44.1797 30.6851H46.2296Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M50.6949 34.3373H48.6373L51.3099 26.3461H53.8587L56.5313 34.3373H54.4737L52.6133 28.3595H52.5514L50.6949 34.3373ZM50.4203 31.1924H54.7212V32.6595H50.4203V31.1924Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M56.1358 27.9147V26.3461H62.8309V27.9147H60.429V34.3373H58.5416V27.9147H56.1358Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M63.7659 34.3373V26.3461H69.2891V27.9147H65.6805V29.5535H69.0067V31.126H65.6805V32.7688H69.2891V34.3373H63.7659Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M74.7697 28.7419C74.7439 28.4558 74.6291 28.2334 74.4254 28.0747C74.2243 27.9134 73.9368 27.8328 73.5629 27.8328C73.3154 27.8328 73.1091 27.8653 72.9441 27.9303C72.7791 27.9953 72.6553 28.0851 72.5728 28.1995C72.4903 28.3114 72.4477 28.4402 72.4452 28.5858C72.44 28.7055 72.4632 28.8109 72.5148 28.9019C72.5689 28.993 72.6463 29.0736 72.7468 29.1438C72.85 29.2115 72.9737 29.2713 73.1181 29.3233C73.2625 29.3753 73.425 29.4209 73.6055 29.4599L74.2862 29.616C74.6781 29.7018 75.0236 29.8163 75.3227 29.9593C75.6244 30.1024 75.8771 30.2728 76.0808 30.4705C76.2871 30.6682 76.4431 30.8958 76.5488 31.1533C76.6545 31.4109 76.7087 31.6996 76.7113 32.0196C76.7087 32.5242 76.5823 32.9574 76.3322 33.3189C76.0821 33.6805 75.7224 33.9576 75.2531 34.1501C74.7864 34.3426 74.223 34.4388 73.5629 34.4388C72.9003 34.4388 72.3227 34.3387 71.8302 34.1384C71.3377 33.938 70.9548 33.6337 70.6815 33.2253C70.4081 32.8169 70.2676 32.3005 70.2599 31.6762H72.0932C72.1087 31.9337 72.177 32.1483 72.2982 32.32C72.4194 32.4917 72.5857 32.6218 72.7971 32.7102C73.0111 32.7987 73.2587 32.8429 73.5397 32.8429C73.7976 32.8429 74.0167 32.8078 74.1972 32.7375C74.3803 32.6673 74.5208 32.5698 74.6188 32.4449C74.7168 32.32 74.7671 32.177 74.7697 32.0157C74.7671 31.8648 74.7207 31.736 74.6304 31.6294C74.5402 31.5201 74.4009 31.4265 74.2127 31.3484C74.0271 31.2678 73.7898 31.1937 73.501 31.126L72.6733 30.9309C71.9875 30.7722 71.4473 30.516 71.0528 30.1622C70.6582 29.8059 70.4623 29.3246 70.4649 28.7185C70.4623 28.2243 70.5938 27.7911 70.8594 27.4192C71.125 27.0472 71.4924 26.7571 71.9617 26.549C72.431 26.3409 72.966 26.2369 73.5668 26.2369C74.1805 26.2369 74.7129 26.3422 75.1642 26.5529C75.618 26.761 75.97 27.0537 76.2201 27.4309C76.4702 27.8081 76.5978 28.2451 76.603 28.7419H74.7697Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M3.06592 12.9378V34.7014H18.3953V18.8451H33.7247V12.9378L18.3953 2.28916L3.06592 12.9378Z"
                            fill="#1630AC"
                        />
                        <path
                            d="M18.3944 18.86H33.7238L18.3944 34.702V18.86Z"
                            fill="#081265"
                        />
                        <path
                            d="M33.7231 30.9691C33.7231 33.0307 32.1243 34.7019 30.152 34.7019C28.1798 34.7019 26.581 33.0307 26.581 30.9691C26.581 28.9074 28.1798 27.2362 30.152 27.2362C32.1243 27.2362 33.7231 28.9074 33.7231 30.9691Z"
                            fill="#1630AC"
                        />
                    </svg> */}
                    <Image src="https://zeitro-images.s3.us-west-1.amazonaws.com/bluerate-logo.png" alt="welcome-modal-image" width={150} height={'auto'} />
                    <div className="login-tips-modal-content-title">
                        You're Live on Bluerate!
                    </div>
                    <div className="login-tips-modal-content-subTitle">
                        Your verification is complete! You now enjoy:
                    </div>
                    <ul className="login-tips-modal-content-ul">
                        <li>Increased visibility to potential borrowers</li>
                        <li>Showcasing your expertise & experience</li>
                        <li>Access to more qualified leads</li>
                    </ul>
                    <div className="login-tips-modal-content-description">
                        Manage your status anytime in Growth Hub &gt;
                        Bluerate Visit &nbsp;
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                track(STATSIG.DASHBOARD.BLUERATE_OPEN)
                                window.open(marketplaceUrl, '_blank')
                            }}
                        >
                            <span className="login-tips-modal-content-link">
                                bluerate.ai
                            </span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M11.5237 8.47631C10.2219 7.17456 8.11139 7.17456 6.80964 8.47631L3.47631 11.8096C2.17456 13.1114 2.17456 15.2219 3.47631 16.5237C4.77806 17.8254 6.88861 17.8254 8.19036 16.5237L9.10832 15.6057M8.47631 11.5237C9.77806 12.8254 11.8886 12.8254 13.1904 11.5237L16.5237 8.19036C17.8254 6.88861 17.8254 4.77806 16.5237 3.47631C15.2219 2.17456 13.1114 2.17456 11.8096 3.47631L10.8933 4.39265"
                                    stroke="#325CEB"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                </div>
            </Modal>
            <LodestarIntegrationNotice open={isLodestarNoticeOpen} onEnable={() => setEnableCount(4)} onClose={() => {setIsLodestarNoticeOpen(false); setEnableCount(closingfeeConfig.lodeStarConfig.suggestEnableCount ? closingfeeConfig.lodeStarConfig.suggestEnableCount + 1 : 2)}} />
            
            {/* 推荐弹窗 */}
            <Modal
                className="recommendation-modal"
                centered={true}
                open={showRecommendationModal}
                onOk={handleModalClose}
                onCancel={handleModalClose}
                width={410}
                maskClosable={false}
                closable={true}
                footer={null}
            >
                <div className="recommendation-modal-content">
                    {/* 图片部分 */}
                    <div className="recommendation-modal-image">
                        {subscription?.plan === 'starter' ? svg_free_plan() : svg_paid_plan()}
                    </div>
                    
                    {/* 文本部分 - 根据 plan 显示不同文案 */}
                    <div className="recommendation-modal-content-title">
                        {subscription?.plan === 'starter' 
                            ? <div>
                                Individual plan is now <span className="recommendation-modal-content-title-price">$8 a month</span> (previously $99 a month). You can also upgrade to <span className="recommendation-modal-content-title-price">$35/mo</span> for your entire company.
                            </div> 
                            : <div>
                                You're now paying just <span className="recommendation-modal-content-title-price">$35/month</span> for full team access—up to 30 seats (previously $99 per user/month).
                            </div>
                        }
                    </div>
                    
                    {/* 按钮部分 */}
                    <div className="recommendation-modal-actions">
                        <div
                            className="see-pricing-btn"
                            onClick={() => {
                                // 先关闭弹窗并更新状态
                                track(STATSIG.DASHBOARD.PRICING_OPEN)
                                handleModalClose()
                                // 更新 sessionStorage 中的 path
                                sessionStorage.setItem('path', 'Pricing')
                                // 跳转到 Plans and Pricing 页面
                                history.push('/app/management?select=Pricing')
                            }}
                        >
                            See new pricing
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default WelcomePage
